import { AdminAppState, PlaceEntry } from '../../state';
import { getPlace } from './get-place';

export const getPlaceId = (placeKey: string) => (
  store: AdminAppState,
): PlaceEntry['place']['id'] => getPlace(placeKey)(store).id;
